// extracted by mini-css-extract-plugin
export default {"container":"AboutUs_container__w-XS+","bookNowBtnStyle":"AboutUs_bookNowBtnStyle__TfpkY"};